import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { getData } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { errorLogger } from '@utils/applicationLogUtils';
import ChevronRight from '../../../../../assets/svg_main/chevron-right-black.svg';
import './PregnancyList.css';

interface PregnancyListProps {
  onPregnancySelect: (pregnancy: any) => void;
}

const PregnancyList: React.FC<PregnancyListProps> = ({ onPregnancySelect }) => {
  const [pregnancyList, setPregnancyList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const benfDetails = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryDetails,
  );

  const fetchPregnancyList = async () => {
    try {
      setLoading(true);
  
      const response = await getData<any>(
        `${endpoints.getPregnancyHistory(benfDetails?.[0]?.benef_id)}`,
      );

      
      const pregnancyData = response?.data || [];
      const formattedData = pregnancyData.map(
        (pregnancy: any, index: number) => ({
          jssk_id: pregnancy.pregnancy_id,
          pregnancy_number: `Pregnancy ${pregnancyData.length - index}`,
          pregnancy_id: pregnancy.pregnancy_id,
          service_date: pregnancy.lmp || pregnancy.date_of_registration,
          facility_type_name: pregnancy.facility_type_name || '-',
          facility_name: pregnancy.facility_name || '-',
          healthprovider_f_name: pregnancy.healthprovider_f_name || '',
          healthprovider_l_name: pregnancy.healthprovider_l_name || '',
          mobiliser_f_name: pregnancy.mobiliser_f_name || '',
          mobiliser_l_name: pregnancy.mobiliser_l_name || '',
          delivery_status: pregnancy.delivery_status || pregnancy.module_code,
          is_pregnancy_outside_rch: pregnancy.is_pregnancy_outside_rch,
        }));

      setPregnancyList(formattedData);
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
      setPregnancyList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (benfDetails?.[0]?.benef_id) {
      fetchPregnancyList();
    }
    
  }, [benfDetails]);

  const handlePregnancyClick = (pregnancy: any) => {
    onPregnancySelect(pregnancy);
  };

  return (
    <div className="jssk-pregnancy-list-container">
      <div className="jssk-section-header">JSSK Services</div>
      <div className="pregnancy-list-content">
        {loading ? (
          <div className="jssk-loading">Loading Pregnancy List...</div>
        ) : pregnancyList?.length > 0 ? (
          pregnancyList.map((pregnancy: any, index: number) => (
            <div
              className="jssk-pregnancy-card"
              key={index}
              onClick={() => handlePregnancyClick(pregnancy)}
            >
              <div className="jssk-pregnancy-card-header">
                <div className="pregnancy-left-container">
                  <div className="pregnancy-label">
                    {pregnancy.pregnancy_number}
                  </div>
                  <div className="pregnancy-sub-info">
                  </div>
                </div>
                <div className="pregnancy-actions">
                  <span data-testid="view-pregnancy-details-icon">
                    <ChevronRight />
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="jssk-no-data">No Pregnancy Records found</div>
        )}
      </div>
    </div>
  );
};

export default PregnancyList;
